"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addResident = addResident;
exports.create = create;
exports.createAmenityCard = createAmenityCard;
exports.deleteAmenityCard = deleteAmenityCard;
exports.deleteUnit = deleteUnit;
exports.editAmenityCard = editAmenityCard;
exports.editResident = editResident;
exports.expireAmenityCard = expireAmenityCard;
exports.get = get;
exports.list = list;
exports.listAmenityCards = listAmenityCards;
exports.listFloors = listFloors;
exports.listLines = listLines;
exports.patchResident = patchResident;
exports.removeResident = removeResident;
exports.searchUserByPhone = searchUserByPhone;
exports.sendAmenityCardLink = sendAmenityCardLink;
exports.unitsWatcher = unitsWatcher;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../variables");
var _helpers = require("@qwkin/helpers");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _variables3 = require("../../Auth/variables");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(unitsWatcher);
function deleteUnit(_ref) {
  var payload = _ref.payload,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? _helpers.identity : _ref$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.UnitService["delete"], payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_UNIT_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Unit deleted successfully'
            }
          });
        case 8:
          callback();
          _context.next = 19;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 16;
          return (0, _effects.put)({
            type: _variables.DELETE_UNIT_FAIL,
            payload: _response
          });
        case 16:
          _context.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 18:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  })();
}
function searchUserByPhone(_ref3) {
  var payload = _ref3.payload,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? _helpers.identity : _ref3$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _response$data3, response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.UnitService.searchResidentByPhoneOrEmail, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables.SEARCH_USER_BY_PHONE_SUCCESS,
            payload: response
          });
        case 6:
          callback((_response$data3 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data3 !== void 0 ? _response$data3 : {});
          _context2.next = 17;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 14;
          return (0, _effects.put)({
            type: _variables.SEARCH_USER_BY_PHONE_FAIL,
            payload: _response2
          });
        case 14:
          _context2.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 16:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9]]);
  })();
}
function listAmenityCards(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.UnitService.listAmenityCards, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITY_CARDS_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 16;
          break;
        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITY_CARDS_FAIL,
            payload: _response3
          });
        case 13:
          _context3.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 15:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 8]]);
  })();
}
function createAmenityCard(_ref7) {
  var payload = _ref7.payload,
    _ref7$callback = _ref7.callback,
    callback = _ref7$callback === void 0 ? _helpers.identity : _ref7$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.UnitService.createAmenityCard, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_AMENITY_CARDS_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables.SHOULD_UPDATE_DATA
          });
        case 8:
          _context4.next = 10;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Amenity card created successfully'
            }
          });
        case 10:
          callback();
          _context4.next = 21;
          break;
        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables.CREATE_AMENITY_CARDS_FAIL,
            payload: _response4
          });
        case 18:
          _context4.next = 20;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 20:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 21:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 13]]);
  })();
}
function editAmenityCard(_ref9) {
  var payload = _ref9.payload,
    _ref9$callback = _ref9.callback,
    callback = _ref9$callback === void 0 ? _helpers.identity : _ref9$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.UnitService.editAmenityCard, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables.EDIT_AMENITY_CARDS_SUCCESS,
            payload: response
          });
        case 6:
          _context5.next = 8;
          return (0, _effects.put)({
            type: _variables.SHOULD_UPDATE_DATA
          });
        case 8:
          _context5.next = 10;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Amenity card edited successfully'
            }
          });
        case 10:
          callback();
          _context5.next = 21;
          break;
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](0);
          _response5 = _context5.t0.response;
          _context5.next = 18;
          return (0, _effects.put)({
            type: _variables.EDIT_AMENITY_CARDS_FAIL,
            payload: _response5
          });
        case 18:
          _context5.next = 20;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 20:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 21:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 13]]);
  })();
}
function deleteAmenityCard(_ref11) {
  var payload = _ref11.payload,
    meta = _ref11.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var _response$data4, response, _response6$data, _response6$data2, _response6;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.UnitService.deleteAmenityCard, payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_AMENITY_CARD_SUCCESS,
            payload: response
          });
        case 6:
          _context6.next = 8;
          return (0, _effects.put)({
            type: _variables.SHOULD_UPDATE_DATA
          });
        case 8:
          _context6.next = 10;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Amenity card deleted successfully'
            }
          });
        case 10:
          meta === null || meta === void 0 || meta.callback((_response$data4 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data4 !== void 0 ? _response$data4 : {});
          _context6.next = 21;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          _response6 = _context6.t0.response;
          _context6.next = 18;
          return (0, _effects.put)({
            type: _variables.DELETE_AMENITY_CARD_FAIL,
            payload: _response6
          });
        case 18:
          _context6.next = 20;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response6$data = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data !== void 0 ? _response6$data : {}),
              data: _response6
            }
          });
        case 20:
          (0, _utils.logErr)((_response6$data2 = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data2 !== void 0 ? _response6$data2 : {});
        case 21:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 13]]);
  })();
}
function expireAmenityCard(_ref13) {
  var payload = _ref13.payload,
    meta = _ref13.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var _response$data5, response, _response7$data, _response7$data2, _response7;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.UnitService.expireAmenityCard, payload);
        case 3:
          response = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)({
            type: _variables.EXPIRE_AMENITY_CARD_SUCCESS,
            payload: response
          });
        case 6:
          _context7.next = 8;
          return (0, _effects.put)({
            type: _variables.SHOULD_UPDATE_DATA
          });
        case 8:
          _context7.next = 10;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Amenity card expired successfully'
            }
          });
        case 10:
          meta === null || meta === void 0 || meta.callback((_response$data5 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data5 !== void 0 ? _response$data5 : {});
          _context7.next = 21;
          break;
        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](0);
          _response7 = _context7.t0.response;
          _context7.next = 18;
          return (0, _effects.put)({
            type: _variables.EXPIRE_AMENITY_CARD_FAIL,
            payload: _response7
          });
        case 18:
          _context7.next = 20;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response7$data = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data !== void 0 ? _response7$data : {}),
              data: _response7
            }
          });
        case 20:
          (0, _utils.logErr)((_response7$data2 = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data2 !== void 0 ? _response7$data2 : {});
        case 21:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 13]]);
  })();
}
function create(_ref15) {
  var payload = _ref15.payload,
    _ref15$onSuccess = _ref15.onSuccess,
    onSuccess = _ref15$onSuccess === void 0 ? _helpers.identity : _ref15$onSuccess;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var response, _response8$data, _response8$data2, _response8;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.UnitService.create, payload);
        case 3:
          response = _context8.sent;
          _context8.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_UNIT_SUCCESS,
            payload: response
          });
        case 6:
          onSuccess(response);
          _context8.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Unit created successfully'
            }
          });
        case 9:
          _context8.next = 19;
          break;
        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](0);
          _response8 = _context8.t0.response;
          _context8.next = 16;
          return (0, _effects.put)({
            type: _variables.CREATE_UNIT_FAIL,
            payload: _response8
          });
        case 16:
          _context8.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response8$data = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data !== void 0 ? _response8$data : {}),
              needAttention: true
            }
          });
        case 18:
          (0, _utils.logErr)((_response8$data2 = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data2 !== void 0 ? _response8$data2 : {});
        case 19:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 11]]);
  })();
}
function listFloors(_ref17) {
  var payload = _ref17.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var response, _response9$data, _response9$data2, _response9;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.UnitService.listFloors, payload);
        case 3:
          response = _context9.sent;
          _context9.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_UNIT_FLOORS_SUCCESS,
            payload: response
          });
        case 6:
          _context9.next = 16;
          break;
        case 8:
          _context9.prev = 8;
          _context9.t0 = _context9["catch"](0);
          _response9 = _context9.t0.response;
          _context9.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_UNIT_FLOORS_FAIL,
            payload: _response9
          });
        case 13:
          _context9.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response9$data = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data !== void 0 ? _response9$data : {}),
              data: _response9
            }
          });
        case 15:
          (0, _utils.logErr)((_response9$data2 = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data2 !== void 0 ? _response9$data2 : {});
        case 16:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 8]]);
  })();
}
function listLines(_ref19) {
  var payload = _ref19.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
    var response, _response10$data, _response10$data2, _response10;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.UnitService.listLines, payload);
        case 3:
          response = _context10.sent;
          _context10.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_UNIT_LINES_SUCCESS,
            payload: response
          });
        case 6:
          _context10.next = 16;
          break;
        case 8:
          _context10.prev = 8;
          _context10.t0 = _context10["catch"](0);
          _response10 = _context10.t0.response;
          _context10.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_UNIT_LINES_FAIL,
            payload: _response10
          });
        case 13:
          _context10.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response10$data = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data !== void 0 ? _response10$data : {}),
              data: _response10
            }
          });
        case 15:
          (0, _utils.logErr)((_response10$data2 = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data2 !== void 0 ? _response10$data2 : {});
        case 16:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 8]]);
  })();
}
function list(_ref21) {
  var payload = _ref21.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
    var response, _response11$data, _response11$data2, _response11;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_services.UnitService.list, payload);
        case 3:
          response = _context11.sent;
          _context11.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_UNITS_SUCCESS,
            payload: response
          });
        case 6:
          _context11.next = 16;
          break;
        case 8:
          _context11.prev = 8;
          _context11.t0 = _context11["catch"](0);
          _response11 = _context11.t0.response;
          _context11.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_UNITS_FAIL,
            payload: _response11
          });
        case 13:
          _context11.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response11$data = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data !== void 0 ? _response11$data : {}),
              data: _response11
            }
          });
        case 15:
          (0, _utils.logErr)((_response11$data2 = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data2 !== void 0 ? _response11$data2 : {});
        case 16:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 8]]);
  })();
}
function get(_ref23) {
  var payload = _ref23.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
    var response, _response12$data, _response12$data2, _response12;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.UnitService.get, payload);
        case 3:
          response = _context12.sent;
          _context12.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_UNIT_SUCCESS,
            payload: response
          });
        case 6:
          _context12.next = 16;
          break;
        case 8:
          _context12.prev = 8;
          _context12.t0 = _context12["catch"](0);
          _response12 = _context12.t0.response;
          _context12.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_UNIT_FAIL,
            payload: _response12
          });
        case 13:
          _context12.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response12$data = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data !== void 0 ? _response12$data : {}),
              data: _response12
            }
          });
        case 15:
          (0, _utils.logErr)((_response12$data2 = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data2 !== void 0 ? _response12$data2 : {});
        case 16:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 8]]);
  })();
}
function removeResident(_ref25) {
  var payload = _ref25.payload,
    _ref25$callback = _ref25.callback,
    callback = _ref25$callback === void 0 ? _helpers.identity : _ref25$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
    var response, _response13$data, _response13$data2, _response13;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.UnitService.removeFromUnit, payload);
        case 3:
          response = _context13.sent;
          _context13.next = 6;
          return (0, _effects.put)({
            type: _variables.REMOVE_RESIDENT_FROM_UNIT_SUCCESS,
            payload: response
          });
        case 6:
          _context13.next = 8;
          return (0, _effects.put)({
            type: _variables.SHOULD_UPDATE_DATA
          });
        case 8:
          _context13.next = 10;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Resident removed successfully'
            }
          });
        case 10:
          callback();
          _context13.next = 21;
          break;
        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](0);
          _response13 = _context13.t0.response;
          _context13.next = 18;
          return (0, _effects.put)({
            type: _variables.REMOVE_RESIDENT_FROM_UNIT_FAIL,
            payload: _response13
          });
        case 18:
          _context13.next = 20;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response13$data = _response13 === null || _response13 === void 0 ? void 0 : _response13.data) !== null && _response13$data !== void 0 ? _response13$data : {}),
              data: _response13
            }
          });
        case 20:
          (0, _utils.logErr)((_response13$data2 = _response13 === null || _response13 === void 0 ? void 0 : _response13.data) !== null && _response13$data2 !== void 0 ? _response13$data2 : {});
        case 21:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 13]]);
  })();
}
function editResident(_ref27) {
  var payload = _ref27.payload,
    _ref27$callback = _ref27.callback,
    callback = _ref27$callback === void 0 ? _helpers.identity : _ref27$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
    var response, _response14$data, _response14$data2, _response14;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.UnitService.editResidentFromUnit, payload);
        case 3:
          response = _context14.sent;
          _context14.next = 6;
          return (0, _effects.put)({
            type: _variables.EDIT_RESIDENT_FROM_UNIT_SUCCESS,
            payload: response
          });
        case 6:
          _context14.next = 8;
          return (0, _effects.put)({
            type: _variables.SHOULD_UPDATE_DATA
          });
        case 8:
          _context14.next = 10;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Resident edited successfully'
            }
          });
        case 10:
          callback();
          _context14.next = 21;
          break;
        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14["catch"](0);
          _response14 = _context14.t0.response;
          _context14.next = 18;
          return (0, _effects.put)({
            type: _variables.EDIT_RESIDENT_FROM_UNIT_FAIL,
            payload: _response14
          });
        case 18:
          _context14.next = 20;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response14$data = _response14 === null || _response14 === void 0 ? void 0 : _response14.data) !== null && _response14$data !== void 0 ? _response14$data : {}),
              data: _response14
            }
          });
        case 20:
          (0, _utils.logErr)((_response14$data2 = _response14 === null || _response14 === void 0 ? void 0 : _response14.data) !== null && _response14$data2 !== void 0 ? _response14$data2 : {});
        case 21:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 13]]);
  })();
}
function patchResident(_ref29) {
  var payload = _ref29.payload,
    _ref29$callback = _ref29.callback,
    callback = _ref29$callback === void 0 ? _helpers.identity : _ref29$callback,
    _ref29$self = _ref29.self,
    self = _ref29$self === void 0 ? false : _ref29$self;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
    var response, _response15$data, _response15$data2, _response15;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.UnitService.patchResidentFromUnit, payload);
        case 3:
          response = _context15.sent;
          if ((0, _helpers.isObjNullOrEmpty)(payload === null || payload === void 0 ? void 0 : payload.type)) {
            _context15.next = 7;
            break;
          }
          _context15.next = 7;
          return (0, _effects.call)(_services.UnitService.patchResidentTypeFromUnit, payload);
        case 7:
          _context15.next = 9;
          return (0, _effects.put)({
            type: _variables.PATCH_RESIDENT_FROM_UNIT_SUCCESS,
            payload: response
          });
        case 9:
          if (!self) {
            _context15.next = 12;
            break;
          }
          _context15.next = 12;
          return (0, _effects.put)({
            type: _variables3.EDIT_USER_DATA,
            payload: response
          });
        case 12:
          _context15.next = 14;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Resident edited successfully'
            }
          });
        case 14:
          callback();
          _context15.next = 25;
          break;
        case 17:
          _context15.prev = 17;
          _context15.t0 = _context15["catch"](0);
          _response15 = _context15.t0.response;
          _context15.next = 22;
          return (0, _effects.put)({
            type: _variables.PATCH_RESIDENT_FROM_UNIT_FAIL,
            payload: _response15
          });
        case 22:
          _context15.next = 24;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response15$data = _response15 === null || _response15 === void 0 ? void 0 : _response15.data) !== null && _response15$data !== void 0 ? _response15$data : {}),
              data: _response15
            }
          });
        case 24:
          (0, _utils.logErr)((_response15$data2 = _response15 === null || _response15 === void 0 ? void 0 : _response15.data) !== null && _response15$data2 !== void 0 ? _response15$data2 : {});
        case 25:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 17]]);
  })();
}
function addResident(_ref31) {
  var payload = _ref31.payload,
    meta = _ref31.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
    var response, _response16$data, _response16$data2, _response16;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.call)(_services.UnitService.addResidentToUnit, payload);
        case 3:
          response = _context16.sent;
          _context16.next = 6;
          return (0, _effects.put)({
            type: _variables.ADD_RESIDENT_TO_UNIT_SUCCESS,
            payload: response
          });
        case 6:
          _context16.next = 8;
          return (0, _effects.put)({
            type: _variables.SHOULD_UPDATE_DATA
          });
        case 8:
          _context16.next = 10;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Resident added successfully'
            }
          });
        case 10:
          meta === null || meta === void 0 || meta.callback();
          _context16.next = 21;
          break;
        case 13:
          _context16.prev = 13;
          _context16.t0 = _context16["catch"](0);
          _response16 = _context16.t0.response;
          _context16.next = 18;
          return (0, _effects.put)({
            type: _variables.ADD_RESIDENT_TO_UNIT_FAIL,
            payload: _response16
          });
        case 18:
          _context16.next = 20;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response16$data = _response16 === null || _response16 === void 0 ? void 0 : _response16.data) !== null && _response16$data !== void 0 ? _response16$data : {}),
              data: _response16
            }
          });
        case 20:
          (0, _utils.logErr)((_response16$data2 = _response16 === null || _response16 === void 0 ? void 0 : _response16.data) !== null && _response16$data2 !== void 0 ? _response16$data2 : {});
        case 21:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 13]]);
  })();
}
function sendAmenityCardLink(_ref33) {
  var payload = _ref33.payload,
    meta = _ref33.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
    var response, _response17$data, _response17$data2, _response17;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return (0, _effects.call)(_services.UnitService.sendAmenityCardLink, payload);
        case 3:
          response = _context17.sent;
          _context17.next = 6;
          return (0, _effects.put)({
            type: _variables.SEND_AMENITY_CARD_LINK_SUCCESS,
            payload: response
          });
        case 6:
          _context17.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'SMS resent successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback();
          _context17.next = 19;
          break;
        case 11:
          _context17.prev = 11;
          _context17.t0 = _context17["catch"](0);
          _response17 = _context17.t0.response;
          _context17.next = 16;
          return (0, _effects.put)({
            type: _variables.SEND_AMENITY_CARD_LINK_FAIL,
            payload: _response17
          });
        case 16:
          _context17.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response17$data = _response17 === null || _response17 === void 0 ? void 0 : _response17.data) !== null && _response17$data !== void 0 ? _response17$data : {}),
              data: _response17
            }
          });
        case 18:
          (0, _utils.logErr)((_response17$data2 = _response17 === null || _response17 === void 0 ? void 0 : _response17.data) !== null && _response17$data2 !== void 0 ? _response17$data2 : {});
        case 19:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[0, 11]]);
  })();
}
function unitsWatcher() {
  return _regenerator["default"].wrap(function unitsWatcher$(_context18) {
    while (1) switch (_context18.prev = _context18.next) {
      case 0:
        _context18.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.CREATE_UNIT_REQUEST, create), (0, _effects.takeLatest)(_variables.LIST_UNITS_REQUEST, list), (0, _effects.takeLatest)(_variables.LIST_UNIT_FLOORS_REQUEST, listFloors), (0, _effects.takeLatest)(_variables.LIST_UNIT_LINES_REQUEST, listLines), (0, _effects.takeLatest)(_variables.GET_UNIT_REQUEST, get), (0, _effects.takeLatest)(_variables.DELETE_UNIT_REQUEST, deleteUnit), (0, _effects.takeLatest)(_variables.REMOVE_RESIDENT_FROM_UNIT_REQUEST, removeResident), (0, _effects.takeLatest)(_variables.EDIT_RESIDENT_FROM_UNIT_REQUEST, editResident), (0, _effects.takeLatest)(_variables.PATCH_RESIDENT_FROM_UNIT_REQUEST, patchResident), (0, _effects.takeLatest)(_variables.ADD_RESIDENT_TO_UNIT_REQUEST, addResident), (0, _effects.takeLatest)(_variables.LIST_AMENITY_CARDS_REQUEST, listAmenityCards), (0, _effects.takeLatest)(_variables.EDIT_AMENITY_CARDS_REQUEST, editAmenityCard), (0, _effects.takeLatest)(_variables.CREATE_AMENITY_CARDS_REQUEST, createAmenityCard), (0, _effects.takeLatest)(_variables.DELETE_AMENITY_CARD_REQUEST, deleteAmenityCard), (0, _effects.takeLatest)(_variables.EXPIRE_AMENITY_CARD_REQUEST, expireAmenityCard), (0, _effects.takeLatest)(_variables.SEARCH_USER_BY_PHONE_REQUEST, searchUserByPhone), (0, _effects.takeLatest)(_variables.SEND_AMENITY_CARD_LINK_REQUEST, sendAmenityCardLink)]);
      case 2:
      case "end":
        return _context18.stop();
    }
  }, _marked);
}